<template>
  <div :class="getLogotitle==-1?'logoheader':'nav-con'">
    <div class="container">
      <img @click="topath('/')" class="logo cursor" src="../assets/img/logo.png" alt="logo">
      <div class="nav-wrap" v-if="getLogotitle!=-1">
        <ul class="main-nav">
          <template v-for="(item,index) in navlist" >
            <li class="nav-a cursor" :class="getLogotitle==index?'active':''" 
            :key="index" @click="searchJump(item,index)" >
              <div class="txt">{{item.name}}</div>
              <div v-if="index!=navlist.length-1" class="div_left"></div>
            </li>
          </template>
        </ul>
        <div class="nav-search">
          <!-- <div class="other-nav" @click="topath('/my',{type:'home'})">我的参拍 </div> -->
          <!-- <el-input class="input1" size="mini" placeholder="请输入关键字" v-model="keyword">
            <el-button slot="append" icon="el-icon-search" @click="serchlist"></el-button>
          </el-input> -->
          <input v-model="keyword" type="text" placeholder="请输入关键字">
          <span @click="serchlist">搜索</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logotitle',
  props: {
    logo:{
      type:  Boolean,
      default: false,
    }
  },
  data() {
    return {
      navlist:[
        {id:1,name:'首页',path:'/'},
        {id:2,name:'标的',path:'/lots'},
        {id:3,name:'拍卖会',path:'/meeting'},
        {id:4,name:'拍卖公告',path:'/notice'},
        {id:5,name:'循环租赁',path:'/lease'},
      ],
      keyword:'',
    }
  },
  watch:{
    keyword(n,o){
      this.$store.commit('setKeyWord',n)
    }
  },
  created(){
  },
  computed:{
    getLogotitle(){
      return this.$store.getters.getLogotitle;
    }
  },
  methods:{
    serchlist(){
      // 不做跳转传参了 放到store里
      this.topath(this.navlist[this.getLogotitle?this.getLogotitle:1].path,{time:Date.now()})
    },
    searchJump(item,index){
      this.$store.commit('setLogotitle',index)
      if(item.id == 5){
        this.topath(item.path)
      }else{
        this.topath(item.path)
      }
    }
  }
}
</script>

<style lang="scss">
.logoheader {
    width: 100%;
    height: 98px;
    font-size: 16px;
    line-height: 130px;
    border-bottom: 1px solid $--color-primary;
    background: #fff;
    padding: 10px 0;
    .container{
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      overflow: hidden;
      .logo{height:100%;width: auto;}
    }
}
.nav-con {
  // border-top: 1px solid $--color-primary;
  background: #fff;
  position: relative;
  z-index: 99;
  .logo{
    text-align: left;
    float: left;
    padding: 7px 0 0;
    width: 217px;
  }
  .nav-wrap {
    margin-left: 217px;
    padding: 20px 0;
    position: relative;
    width: 983px;
    .main-nav {
      display: flex;
      align-items: center;
      height: 33px;
      overflow: hidden;
      padding-left: 20px;
      .nav-a {
        min-width: 54px;
        height: 34px;
        padding: 0 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 500;
        color: #333;
        text-align: center;
        line-height: 34px;
        transform: skewX(-20deg);
        cursor: pointer;
        box-sizing: border-box;
        border-radius: 4px 8px 4px 8px;
        transition: all .2s ease-in;
        .txt{
          transform: skewX(20deg);
        }
        .div_left{
          position: absolute;
          right: 0;
          top: 8px;
          width: 1px;
          height: 18px;
          background: #cecece;
        }
      }
      .nav-a:hover, li.active  {
        font-size: 16px;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
        color: #fff;
        background: $--color-primary;
        .txt{
          color: #fff;
        }
      }
    }
  }
  .container {
    position: relative;
    height: 69px;
    overflow: hidden;
  }
  .nav-search {
    position: absolute;
    right: 0;
    top: 20px;
     input{
      width: 180px;
      height: 36px;
      float: left;
      border-radius: 18px 0 0 18px;
      border: 1px solid $--color-primary;
      text-indent: 12px;
    }
    span{
      padding: 0 20px;
      display: inline-block;
      height: 36px;
      line-height: 36px;
      background: $--color-primary;
      border-radius: 0 21px 21px 0;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
}
  .el-select .el-input {
    width: 100px;
  }
  .input1 {
    width: 230px;
    position: relative;
    overflow: hidden;
  }
  .other-nav {
    float: right;
    width: 88px;
    height: 34px;
    text-align: center;
    margin-right: 20px;
    line-height: 34px;
    color: #333;
    font-size: 16px;
    cursor: pointer;
  }
  .other-nav a:hover {
    color: $--color-primary;
  }
}
</style>
